export const GoChangeInputParametersDialogMessage = {
    modalTitle: 'Change Input Parameters',
    modalContent:
        'Changing input parameters will re-run coordination and incur additional charges. Do you want to continue?',
    primaryActionTitle: 'Continue',
};
